// RFC 7807 (application/problem+json)
export interface ProblemDetails {
  type?: string;
  title?: string;
  status?: number;
  detail?: string;
  instance?: string;
  errors?: { [field: string]: string[] };
}

export const isProblemDetails = (value: unknown): value is ProblemDetails =>
  !!value && typeof value === 'object' && ('title' in value || 'errors' in value);

export const getProblemDetailsMessage = (problemDetails: ProblemDetails): string => {
  const fieldErrors = problemDetails.errors
    ? Object.values(problemDetails.errors).reduce((all, messages) => [...all, ...messages], [] as string[])
    : [];

  return fieldErrors.join(' ') || problemDetails.detail || problemDetails.title || '';
};
